import { render } from "./ActionResultTable.vue?vue&type=template&id=b5d1a4e8&ts=true"
import script from "./ActionResultTable.vue?vue&type=script&lang=ts"
export * from "./ActionResultTable.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__